import { type Registry as Services } from '@ember/service';
import ApplicationInstance from '@ember/application/instance';

export function initialize(appInstance: ApplicationInstance) {
  window.addEventListener('unhandledrejection', (event) => {
    const sentry = appInstance.lookup('service:sentry') as Services['sentry'];
    const { reason, promise } = event;

    sentry.captureException(reason, {
      tags: {
        source: 'unhandledrejection',
      },

      extra: {
        reasonAsString: String(reason),
        stack: reason?.stack || null,
        event,
        promise,
      },
    });
  });
}

export default {
  name: 'unhandledrejection',
  initialize,
};
